module.exports = __webpack_public_path__ + "img/index_lou_icon_3_on.bd6f3efe.png";